module.exports = __webpack_public_path__ + "static/img/H3C.fcde9fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/H3C.png
// module id = aZQZ
// module chunks = 1